document.addEventListener("DOMContentLoaded", function() {
  function initializeCustomVariants() {
    const selectItems = document.querySelectorAll(".select-items");
    
    selectItems.forEach((selectItem) => {
      // Verificar si ya está inicializado para evitar duplicados
      if (selectItem.dataset.initialized === 'true') {
        return;
      }
      
      const parent = selectItem.parentElement;
      const form = parent.closest("form");
      
      if (!form) {
        console.warn("No se encontró el formulario para el selector de variantes");
        return;
      }
      
      const variantSelect = form.querySelector('[name="id"]');
      // --- 1. AÑADIMOS EL SELECTOR PARA EL INPUT DEL PLAN ---
      const sellingPlanInput = form.querySelector('[name="selling_plan"]');
      const optionsContainer = parent.querySelector(".select-variants__options");
      const variantInfo = parent.querySelector(".variant-info");
      
      if (!variantSelect || !optionsContainer || !variantInfo) {
        console.warn("Elementos requeridos no encontrados para el selector de variantes");
        return;
      }
      
      const options = optionsContainer.querySelectorAll("label");
      const productCard = selectItem.closest("li");
      const currentPrice = productCard ? productCard.querySelector(".price__current") : null;
      const wasPrice = productCard ? productCard.querySelector(".price__was") : null;

      // Marcar como inicializado
      selectItem.dataset.initialized = 'true';

      // TU LÓGICA ORIGINAL PARA ABRIR/CERRAR EL SELECTOR
      selectItem.addEventListener("click", function(event) {
        console.log("click");
        event.preventDefault();
        
        const activeOptions = [...document.querySelectorAll(".select-variants__options")].filter(
          (option) => option.classList.contains("active")
        );

        if (optionsContainer.classList.contains("active")) {
          if (productCard) productCard.classList.remove("toggle-index");
          optionsContainer.classList.remove("active");
        } else {
          if (productCard) productCard.classList.add("toggle-index");
          optionsContainer.classList.add("active");
        }

        activeOptions.forEach((option) => {
          const optionCard = option.closest("li");
          option.classList.remove("active");
          if (optionCard) optionCard.classList.remove("toggle-index");
        });
      });

      // TU LÓGICA ORIGINAL PARA MANEJAR EL CLIC EN UNA OPCIÓN
      options.forEach((option) => {
        option.addEventListener("click", function(event) {
          event.preventDefault();
          // --- 2. AÑADIMOS 'sellingPlanId' A LA EXTRACCIÓN DE DATOS ---
          const { variantId, price, comparePrice, sellingPlanId } = option.dataset;
          
          if (variantSelect) variantSelect.value = variantId;
          // --- 3. AÑADIMOS LA ACTUALIZACIÓN DEL VALOR DEL PLAN ---
          if (sellingPlanInput) sellingPlanInput.value = sellingPlanId || '';

          if (variantInfo) variantInfo.innerHTML = option.textContent;
          
          optionsContainer.classList.remove("active");
          if (productCard) productCard.classList.remove("toggle-index");
          
          if (currentPrice) currentPrice.innerHTML = price || "";
          if (wasPrice) wasPrice.innerHTML = comparePrice || "";

          const activeOptions = [...document.querySelectorAll(".select-variants__options")].filter(
            (option) => option.classList.contains("active")
          );
          activeOptions.forEach((option) => {
            const optionCard = option.closest("li");
            option.classList.remove("active");
            if (optionCard) optionCard.classList.remove("toggle-index");
          });
        });
      });
    });
  }

  // EL RESTO DE TU SCRIPT DE INICIALIZACIÓN (INTACTO)
  initializeCustomVariants();
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        let shouldReinitialize = false;
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('select-items')) {
              shouldReinitialize = true;
            } else if (node.querySelector && node.querySelector('.select-items')) {
              shouldReinitialize = true;
            }
          }
        });
        
        if (shouldReinitialize) {
          setTimeout(initializeCustomVariants, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  document.addEventListener("searchComplete", function(event) {
    console.log("Evento searchComplete detectado, reinicializando variantes...");
    setTimeout(initializeCustomVariants, 200);
  });
});